import ComponentManager from '@/Management/ComponentManager';
import CheckBox from '@/Controls/CheckBox';
import Button from '@/Controls/Button';
import TwoFactorAuthQRCheckBoxViewModel from '@/Components/TwoFaktorAuth/TwoFactorEnable/TwoFactorAuthQRCheckBoxViewModel';
import TwoFactorPopup from '@/Components/TwoFaktorAuth/PopupWindow/TwoFactorPopup';

/**
 * Bildet die Komponente ab, welche bspw. innerhalb der Useranlage zu finden ist
 */
export default class TwoFactorAuthQRCheckBox extends CheckBox {
    private qrCodeWindow: TwoFactorPopup;

    public constructor(protected viewModel: TwoFactorAuthQRCheckBoxViewModel, protected element?: JQuery) {
        super(viewModel, element);
    }

    /**
     * @override
     * @param widget
     */

    protected onWidgetCreatedCallback(widget: null): void {
        super.onWidgetCreatedCallback(widget);
        this.applyBindings(this.jQueryControl, {
            controlName: 'twofactor'
        });
    }
    
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div><input type="checkbox"><div class="element"></div>&nbsp; </div>')

        const btn = new Button(this.viewModel.useTwoFAButton);
        const btnTule = btn.getTuple();
        btnTule.control.appendTo(this.jQueryControl);

        this.widget(null);

        return this.jQueryControl;
    }
}

ComponentManager.setControl('TwoFactorAuthQRCheckBox', TwoFactorAuthQRCheckBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');